import Button from "../Button"
import ShipmentCard from "./shipmentCard"
import packag from "../../../assets/images/package.png"
import { useMemo } from "react"
import useDashboard from "../../../pages/Dashboard/useDashboard"
import useQuote from "./useQuote"
import InputField from "../Input"
import { placeholder } from "../../../util/placeholder"
import SearchAirportsDropDown from "../searchAirportsDropDown"
import { useSelector } from "react-redux"
import { useToggleThrough } from "../../../Hooks/GlobalHook"
import GetQuoteModal from "./getQuoteModal"
import SendingParcels from "../../../pages/SendingParcel"
import ShipmentModal from "./shipmentModal"
// import renderInput from "./quoteInput/renderInput"
// import Select from "../../../components/shared-components/select/Select"
// import { labelName } from "../../../util/shipmentLabelName"
// import { boolean, shipmentData } from "../../../components/data/optionData"
// import {
//   countryData,
//   countryAirportDataFormatted,
// } from "../../../components/data/optionData"
// import InputFields from "../../../components/shared-components/input-fields"
// import { useState } from "react"

const GetQuote = () => {
  // const [filteredCountryAirport, setFilteredCountryAirport] = useState([])
  // const [
  //   destinationFilteredCountryAirport,
  //   setDestinationFilteredCountryAirport,
  // ] = useState([])
  const { airports } = useSelector((state) => state.airports)
  const { shipment } = useDashboard()
  const { toggleModal, handleToggleModal } = useToggleThrough()
  const {
    selectOptions,
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    isSubmitting,
  } = useQuote()

  const shipmentStatus = useMemo(
    () => (status) => {
      return shipment?.filter((data) => data.status === status)?.length || 0
    },
    [shipment]
  )

  const details = useMemo(
    () => [
      {
        status: "Pending shipments",
        value: shipmentStatus("pending"),
        bg: "bg-secondary-100",
      },
      {
        status: "Delivered shipments",
        value: shipmentStatus("completed"),
        bg: "bg-primary-100",
      },
      {
        status: "Cancelled shipments",
        value: shipmentStatus("cancelled"),
        bg: "bg-primary-200",
      },
    ],
    [shipmentStatus]
  )
  // function selectDataType(value) {
  //   if (value === "shipment_type") {
  //     return shipmentData
  //   } else if (value === "destination" || value === "departure") {
  //     return countryData
  //   }
  //   // else if(value === "departure_airport" || value === "destination_airport"){
  //   //   const _countryCode = value.split('-')[1]
  //   //   //filter countryAirportDataFormatted using the country that matches and return it
  //   //   const _filteredData = countryAirportDataFormatted.filter(data => data.country == _countryCode)
  //   //   setFilteredCountryAirport(()=> _filteredData)
  //   //   return _filteredData

  //   // }
  //   return boolean
  // }

  // function numberField(field) {
  //   if (
  //     field === "shipment_item_worth" ||
  //     field === "shipping_quantity" ||
  //     field === "lenght" ||
  //     field === "height" ||
  //     field === "width" ||
  //     field === "weight"
  //   )
  //     return "number"
  //   else if (field === "shipment_date") return "date"
  //   return "text"
  // }

  // function _filteredCountryAirport(country) {
  //   const _countryCode = country.split("-")[1]
  //   //filter countryAirportDataFormatted using the country that matches and return it
  //   const _filteredData = countryAirportDataFormatted.filter(
  //     (data) => data.country == _countryCode
  //   )
  //   setFilteredCountryAirport(() =>
  //     _filteredData?.sort((a, b) =>
  //       a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  //     )
  //   )
  //   return
  // }

  // function _destinationFilteredCountryAirport(country) {
  //   const _countryCode = country.split("-")[1]
  //   //filter countryAirportDataFormatted using the country that matches and return it
  //   const _filteredData = countryAirportDataFormatted.filter(
  //     (data) => data.country == _countryCode
  //   )
  //   setDestinationFilteredCountryAirport(() =>
  //     _filteredData?.sort((a, b) =>
  //       a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  //     )
  //   )
  //   return
  // }

  return (
    <>
      <div className="xl:flex  w-full gap-[1.5rem] space-y-[1.8rem] xl:space-y-0">
        <div className="w-full xl:w-[60%] flex flex-col justify-between gap-y-[1rem]">
          <div className="xl:flex justify-between items-start w-full rounded-[1.1rem] py-[1.5rem] px-[1.5rem] md:px-[2.5rem] bg-primary-300">
            <div>
              <h1 className="text-[2rem] xl:text-[2.3rem] text-white font-medium w-[19rem] md:w-[22rem]">
                Seamless logistics starts here
              </h1>
              <div className="mt-[1.4rem] xl:mt-[3rem]">
                <Button
                  text={"Lodge Shipment"}
                  className={"text-primary-300 bg-white"}
                  onClick={() => handleToggleModal("lodgeShipment")}
                />
              </div>
            </div>
            <div className="flex justify-end mt-[1rem]">
              <img src={packag} alt="package" className="max-w-full" />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-[1rem]">
            {details.map((item, index) => (
              <ShipmentCard
                key={index}
                status={item.status}
                value={item.value}
                bg={item.bg}
                index={index}
              />
            ))}
          </div>
        </div>

        <div className="w-full xl:w-[40%] rounded-[1.1rem] py-[1.3rem] px-[1.2rem] md:px-[2.3rem] bg-primary-100">
          <h2 className="text-[2rem] text-black font-medium">
            Get an Instant Quotes
          </h2>
          <form onSubmit={handleSubmit} className="mt-[0.9rem]">
            <div className="space-y-7 h-[50vh] overflow-y-scroll">
              {Object.entries(values).map(([key, value], i) => (
                <div
                  key={i}
                  className="flex-col bg-white rounded-[0.5rem] px-2 "
                >
                  {/* <label className="text-[0.8rem] text-[#2C2C2C] font-gothic ">
                    {placeholder(key)}
                  </label> */}
                  {key === "departure" || key === "destination" ? (
                    <SearchAirportsDropDown
                      sortedAirports={airports}
                      fieldName={key}
                      value={value}
                      onChange={handleChange}
                      placeholder={placeholder(key)}
                      setFieldValue={setFieldValue}
                      className={"!pt-[1.7rem] !pb-[1.1rem]"}
                    />
                  ) : (
                    <InputField
                      placeholder={placeholder(key)}
                      type={
                        key === "shipment_date"
                          ? "date"
                          : key === "weight"
                          ? "number"
                          : key === "email"
                          ? "email"
                          : "text"
                      }
                      required
                      className={"bg-white !px-0 !pt-[1.7rem] !pb-[1.1rem]"}
                      value={value}
                      name={key}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      errors={errors[key]}
                      touched={touched[key]}
                      key={key}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="mt-[1.4rem]">
              <Button
                isSubmitting={isSubmitting}
                disabled={
                  values.departure === "" ||
                  values.destination === "" ||
                  isSubmitting
                }
                text="Get Quotes"
                className="text-white bg-primary-500"
                type="submit"
              />
            </div>
          </form>
        </div>
      </div>
      {toggleModal.lodgeShipment && <ShipmentModal />}
    </>
  )
}

export default GetQuote
